import { apiMdl } from "./api.middleware"
import { userMdl } from "./user.middleware"
import { vesselsMdl } from './vessels.middleware'
import { mapDataMdl } from "./map-data.middleware"
import { fleetMdl } from "./fleet.middleware"
import { alertMdl } from "./alert.middleware"
import { suggestionsMdl } from "./suggestions.middleware"
import { servicesMdl } from "./services.middleware"
import { expectedVesselMdl } from "./expected-vessels.middleware"
import {companyVesselMdl} from "./company-vessel-chart.middleware"

export const middlewares = [
  ...apiMdl,
  ...userMdl,
  ...vesselsMdl,
  ...mapDataMdl,
  ...fleetMdl,
  ...alertMdl,
  ...suggestionsMdl,
  ...servicesMdl,
  ...expectedVesselMdl,
  ...companyVesselMdl
]